<div class="checked-filter-tags">

  <ng-container *ngFor="let item of filter.getFields() | async">
    @if (item.key == 'hasStock') {
      <span *ngIf="showHasStock" size="small">
          <nb-checkbox i18n="@@InStock" [checked]="hasStock" (checkedChange)="onChangeRange($event)">В наличии</nb-checkbox>
        </span>
    }
  </ng-container>

  <ng-container *ngIf="keyword">
    <button (click)="delete('keyword')" i18n-nbTooltip="@@RemoveFromFilter" nbButton nbTooltip="Убрать из фильтра" size="small">
      {{ keyword }}
      <nb-icon icon="close-outline"/>
    </button>
  </ng-container>

  <ng-container *ngIf="catalog?.header">
    <button (click)="delete('catalog_id')" i18n-nbTooltip="@@RemoveFromFilter" nbButton nbTooltip="Убрать из фильтра" size="small">
      {{ catalog.header }}
      <nb-icon icon="close-outline"/>
    </button>
  </ng-container>

  <ng-container *ngFor="let item of filter.getFields() | async">
    @if (!filter.isEmptyField(item) && !item.fieldGroup && item.key != 'hasStock') {
      @if (item.type == 'checkbox') {
        <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)" nbButton size="small">
          {{ item.templateOptions.label }}
          <nb-icon icon="close-outline"/>
        </button>

      } @else if (item.type == 'select-multi-filter-property') {
        <ng-container *ngFor="let itemMulti of item.defaultValue">
          <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key, itemMulti)" nbButton size="small">
            {{ getDisplayValue(item, itemMulti) }}
            <nb-icon icon="close-outline"/>
          </button>
        </ng-container>

      } @else if (item.type == 'date-range-picker') {
        <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)" nbButton size="small">
          {{ item.templateOptions.label }} {{ item.defaultValue.from }}-{{ item.defaultValue.to }}
          <nb-icon icon="close-outline"/>
        </button>

      } @else {
        <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)" nbButton size="small">
          {{ getDisplayValue(item) }}
          <nb-icon icon="close-outline"/>
        </button>
      }

    } @else if (!filter.isEmptyField(item) && item.fieldGroup) {
      <button nbButton size="small" i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)">
        {{ item.templateOptions.label }}

        {{ item.fieldGroup[0]?.defaultValue }}-{{ item.fieldGroup[1].defaultValue }}

        <ng-container *ngFor="let itemGroup of item.fieldGroup">
          <ng-container *ngIf="itemGroup.key=='start'  && itemGroup.defaultValue!=''">
            {{ itemGroup.defaultValue }}
          </ng-container>
          <ng-container *ngIf="itemGroup.key=='stop' && itemGroup.defaultValue!=''">
            {{ itemGroup.defaultValue }}
          </ng-container>
        </ng-container>
        <nb-icon icon="close-outline"/>
      </button>
    }

  </ng-container>

  <button (click)="reset()" *ngIf="keyword != '' || catalog || (filter.getCtnActiveFeatures() | async)" i18n="@@CancelAllFilters" nbButton size="small" status="control">
    Сбросить фильтры
  </button>

</div>
